import { IQuestionOption } from '@common/types';
import { IMessage } from '@common/types';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';

interface IChoiceResponseProps {
  message: IMessage;
  onSelectChoice: (choice: IQuestionOption | undefined) => void;
}

function ChoiceResponse(props: IChoiceResponseProps) {
  const { t } = useTranslation();

  if (!props.message?.choices) {
    return <>{t('chat.response.no_options')}</>;
  }

  return (
    <AnswerMessageContainer>
      <div>{props.message?.message}</div>
      <ul className="block list-disc my-4 pl-5">
        {props.message.choices.map((choice, idx) => {
          if (!choice) {
            return null;
          }
          if (choice.status === 'infoservice') {
            return null;
          }

          return (
            <li key={idx}>
              <p
                className="cursor-pointer text-blue-500 underline"
                onClick={() => props.onSelectChoice(choice)}
              >
                {choice.actualQuery}
              </p>
            </li>
          );
        })}
      </ul>
      {t('chat.response.no_suitable_answer')} <br />
      <p
        className="cursor-pointer text-blue-500 underline"
        onClick={() => props.onSelectChoice(undefined)}
      >
        {t('chat.response.contact_medical_info')}
      </p>
      {props.message.choices.length === 0 &&
        `,
                 ${t('chat.response.ask_new')}`}
    </AnswerMessageContainer>
  );
}

export default ChoiceResponse;
